<div class="system_assesment p-3">
  <div class="row">
    <div class="col-lg-6">
      <form class="assesment_flex d-flex align-items-end">
        <div class="form-group mb-0">
          <label class="control-label fw" for="impactTemplate">Choose Impact Assessment Template</label>
          <select class="form-control form-control-sm" id="impactTemplate" name="templateNo"
            [(ngModel)]="impactAssessmentTemplateNo">
            <option *ngFor="let option of impactAssessmentTemplateDD" value="{{option.id}}">{{option.title}}</option>
          </select>
        </div>
        <button type="submit" (click)="updateTemplateNo(impactAssessmentTemplateNo)"
          class="btn btn-primary">Change</button>
      </form>
    </div>
    <div class="col-lg-6">
      <form class="assesment_flex d-flex align-items-end">
        <div class="form-group mb-0">
          <label class="control-label fw" for="selfTemplate">Choose Self Assessment Template</label>
          <select class="form-control form-control-sm" id="selfTemplate" name="selftemplateNo"
            [(ngModel)]="selfAssessmentTemplateNo">
            <option *ngFor="let option of selfAssessmentTemplateDD" value="{{option.id}}">{{option.title}}</option>
          </select>
        </div>
        <button type="submit" (click)="updateSelfTemplateNo(selfAssessmentTemplateNo)"
          class="btn btn-primary">Change</button>
      </form>
    </div>
  </div>
</div>
<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>